import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import type { TextInput } from 'react-native';

import { NumberField as GarnishNumberField } from '../NumberField';
import type { ControlledProps, FormProps } from './types';

type ComponentProps = React.ComponentProps<typeof GarnishNumberField>;
type OmittedProps = ControlledProps | 'noticePalette';
type Props = FormProps & Omit<ComponentProps, OmittedProps>;

export const NumberField = forwardRef<TextInput, Props>(
  ({ name, control, rules, notice, ...rest }, ref) => {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { invalid, error },
        }) => (
          <GarnishNumberField
            ref={ref}
            value={value}
            invalid={invalid}
            noticePalette={invalid ? 'caution' : undefined}
            onBlur={onBlur}
            onChangeText={onChange}
            notice={notice ?? error?.message}
            {...rest}
          />
        )}
      />
    );
  },
);
